<nav
  class="bg-purple-21 navbar navbar-primary navbar-primary-2 navbar-primary-home-2 sticky-top navbar-reporting-public">
  <div class="container-fluid flex-column-reverse flex-sm-row no-padding">
    <div class="align-items-center d-flex">
      <button class="d-lg-none lateral-menubar-toggler mgn-rigth-3 navbar-toggler-2" type="button"
        aria-label="Control barra de menú lateral" (click)="onClickToogleMenu($event)"><span class="navbar-toggler-icon"></span>
      </button>
      <div class="clamp-1-text brand-reporting-public">
        <span class="product-name">Canal de denuncias</span><span class="institution-name">{{employerName}}</span>
      </div>
    </div>
    <div *ngIf="employerLogo">
      <div class="navbar-brand no-mgn">
        <div class="d-md-flex d-none wrap-img">
          <img [src]="employerLogo" alt="Logotipo de Profejobs" class="logo-main-navbar" loading="lazy" />
        </div>
      </div>
    </div>
  </div>
</nav>
<main>
  <div class="container-fluid">
    <div class="col-dynamic-width flex-lg-nowrap row">
      <div class="col-12 col-lg-auto col-lateral" [class.d-none]="showLateralBar === false">
        <div class="lateral-menu-bar tab-control wrap-main-module">
          <div class="lateral-menu-wrap-content">


            <button (click)="onClickToogleMenu($event)" type="button"
              class="mgn-rigth-12 btn btn-action-lateral-menu btn-light btn-sm collapse-lateral-menu d-lg-block d-none lateral-menubar-toggler"><i
                class="pj-ico pj-ico-flecha-abajo-usuario"></i>
            </button>

            <button (click)="onClickCloseMenu($event)" type="button"
              class="mgn-rigth-12 btn btn-light btn-sm btn-action-lateral-menu close-lateral-menu d-lg-none"
              title="Cerrar">&times;</button>

              <div class="overflow-y-degraded-border top"></div>
            <div class="lateral-menu-main-content">
              <div class="module-section">
                <h4 class="module-section-heading">Canal de denuncias</h4>
                <ul class="menu-bar-main-module">
                  <li *ngIf="!this.domainService.isActiveSubdomainComplaint()" class="menu-item-main-module compact-mode-menu-item"
                    [ngClass]="{'active': [path_module_complaint.module, path_module_complaint.register] | isActiveRoute : currentTs}">
                    <a [routerLink]="['/', urlEmployer, path_module_complaint.module,path_module_complaint.register]">
                      <div class="menu-item-frame">
                        <div>
                          <i class="pj-ico pj-ico-check-list"></i>
                        </div>
                        <div class="tag-menu-item">
                          Protocolos
                        </div>
                      </div>
                    </a>
                  </li>



                  <li *ngIf="!this.domainService.isActiveSubdomainComplaint()" class="menu-item-main-module compact-mode-menu-item"
                    [ngClass]="{'active': [path_module_complaint.module, path_module_complaint.follow_up] | isActiveRoute : currentTs}">
                    <a [routerLink]="['/', urlEmployer, path_module_complaint.module, path_module_complaint.follow_up]">
                      <div class="menu-item-frame">
                        <div>
                          <i class="pj-ico pj-ico-evaluaciones"></i>
                        </div>
                        <div class="tag-menu-item">
                          Seguimiento de denuncia
                        </div>
                      </div>
                    </a>
                  </li>

                  <li *ngIf="this.domainService.isActiveSubdomainComplaint()" class="menu-item-main-module compact-mode-menu-item"
                    [ngClass]="{'active': ['/'] | isActiveRoute : currentTs}">
                    <a [routerLink]="['/']">
                      <div class="menu-item-frame">
                        <div>
                          <i class="pj-ico pj-ico-check-list"></i>
                        </div>
                        <div class="tag-menu-item">
                          Protocolos
                        </div>
                      </div>
                    </a>
                  </li>



                  <li *ngIf="this.domainService.isActiveSubdomainComplaint()" class="menu-item-main-module compact-mode-menu-item"
                    [ngClass]="{'active': [path_module_complaint.follow_up] | isActiveRoute : currentTs}">
                    <a [routerLink]="['/', path_module_complaint.follow_up]">
                      <div class="menu-item-frame">
                        <div>
                          <i class="pj-ico pj-ico-evaluaciones"></i>
                        </div>
                        <div class="tag-menu-item">
                          Seguimiento de denuncia
                        </div>
                      </div>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
            <div class="overflow-y-degraded-border bottom"></div>
          </div>
        </div>
      </div>
      <div class="col-12  col-dynamic" [class.col-lg-10]="showLateralBar === true">
        <div class="wrap-main-module">

          <router-outlet></router-outlet>


        </div>
      </div>
    </div>
  </div>
</main>
<footer class="footer footer-dark-blue">
  <div class="container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="text-center wrap-widget">
          <p class="copyright-text">&reg; 2024 ProfeJOBS. Todos los derechos reservados.</p>
        </div>
      </div>
    </div>
  </div>
</footer>